import { FilterConfig } from 'components/SearchAndFilters/FilterTypes';
import SearchAndFilters from 'components/SearchAndFilters/index';
import { useSetAtom } from 'jotai';
import React, { Suspense } from 'react';
import { Col, Row } from 'reactstrap';

import { filterValuesAtom, useOnFilterChangeResetRelatedAtoms } from './state';
import { FilterValues } from './types/bpaFindings.types';

const Filters: React.FC<{ filtersConfig: FilterConfig }> = ({
  filtersConfig,
}) => {
  const setFilterValues = useSetAtom(filterValuesAtom);
  const resetRelatedAtoms = useOnFilterChangeResetRelatedAtoms();

  const handleFilterChange = () => {
    const activeValues: FilterValues = {
      ...filtersConfig.getActiveFilterValues(),
    };
    setFilterValues(activeValues);
    resetRelatedAtoms();
  };

  return (
    <Suspense fallback={<></>}>
      <Row className="text-left">
        <Col xs="12">
          <SearchAndFilters
            config={filtersConfig}
            onChange={handleFilterChange}
          />
        </Col>
      </Row>
    </Suspense>
  );
};

export default Filters;
